import { Suspense } from "react";

import { BarLoading } from "@/components/Loading/BarLoading";
import { PageErrorBoundary } from "@/layout/ErrorBoundary/PageErrorBoundary";
import { EmailOnboardPageInternal } from "@/pages/channels/pages/emailOnboard/EmailOnboardPage";

export const EmailOnboardPage: React.FC = function EmailOnboardPage() {
  return (
    <PageErrorBoundary>
      <Suspense fallback={<BarLoading />}>
        <EmailOnboardPageInternal />
      </Suspense>
    </PageErrorBoundary>
  );
};
